import { render, staticRenderFns } from "./ActionsOnSelectedConstructs.vue?vue&type=template&id=1c2e6b46"
import script from "./ActionsOnSelectedConstructs.vue?vue&type=script&lang=ts"
export * from "./ActionsOnSelectedConstructs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports